import { View } from 'foundations-components/components/View';
import { AC_PAGE_MAX_INLINE_SIZE } from 'academy-navigation-lib/components/ACPage/ACPage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const LearningContentInnerWrapper = ({
  children
}) => {
  const {
    isDesktopNavbar
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    paddingBlockEnd: "500",
    paddingInline: isDesktopNavbar ? '1100' : '300',
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: `${AC_PAGE_MAX_INLINE_SIZE}px`,
      children: children
    })
  });
};
export default LearningContentInnerWrapper;